<template>
  <span class="ns_badge label label-important js-tooltip" data-title="Non sostituibile"> NS </span>
</template>
<script>
export default {
  name: 'nsLabel',
};
</script>
